import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Error404Component } from './marketing';
import { UnsubscribeComponent } from './clients/auth/unsubscribe';
import { UnsubscribeSucessComponent } from './clients/auth/unsubscribe/unsubscribe-success.component';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: './admin/admin.module#AdminModule',
  },
  {
    path: 'clients',
    loadChildren: './clients/clients.module#ClientsModule',
  },
  {
    path: 'customers',
    loadChildren: './customers/customers.module#CustomersModule',
  },
  {
    path: 'c/:number',
    redirectTo: 'customers/login/:number',
  },
  {
    path: 'verify/:token',
    redirectTo: 'customers/login/token/:token',
  },
  {
    path: 'unsubscribe',
    component: UnsubscribeComponent
  },
  {
    path: 'unsubscribed',
    component: UnsubscribeSucessComponent
  },
  {
    path: '',
    loadChildren: './marketing/marketing.module#MarketingModule'
  },
  {
    path: '**',
    component: Error404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts